import './discord.css';

const discordGuildId = process.env.DISCORD_GUILD_ID;
const discordInviteUrl = process.env.DISCORD_INVITE_URL;

export default function DiscordInfo(){

	return <div className='discordInfoPanel panel'>
		<h2>Join our Discord!</h2>
		<div className='discordInviteLink'>
			<a href={discordInviteUrl}>
				<img src={`https://discord.com/api/guilds/${discordGuildId}/widget.png?style=banner2`} />
			</a>
		</div>
		<p>
			Races are coordinated in our Discord server. We also have channels dedicated to creating romhacks for various games.
		</p>
	</div>
}